/**
 * Scrolls a section fully into view with its heading just below the sticky nav.
 * Runs a second corrective pass once lazy images have settled the layout.
 */
export function scrollToSection(id: string): void {
  const el = document.getElementById(id)
  if (!el) return

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches
  const offset = window.innerWidth < 1024 ? 96 : 28

  const go = () => {
    const target = el.getBoundingClientRect().top + window.scrollY - offset
    window.scrollTo({
      top: Math.max(0, target),
      behavior: reduceMotion ? 'auto' : 'smooth',
    })
  }

  go()
  window.setTimeout(go, 450)
}
